import { useDisclosure } from '@chakra-ui/hooks'
import { Input } from '@chakra-ui/input'
import { Button } from '@chakra-ui/button'
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
} from '@chakra-ui/modal'
import { ChakraProvider } from '@chakra-ui/provider'
import React from 'react'
import { Text } from '@chakra-ui/layout'
import { Textarea } from '@chakra-ui/textarea'
import Axios from 'axios'
import { baseURL } from '../../../../services/api'

function DrawerUsage({
  open,
  setOpen,
  description = false,
  nunota,
  dadosDrawer,
  submitForm,
}) {
  const btnRef = React.useRef()
  const [desc, setDesc] = React.useState('')
  const [loading, setLoading] = React.useState(false)
  const [chat, setChat] = React.useState([])

  console.log('nunonta', nunota)

  async function submitObs() {
    setLoading(true)

    const codUsuario = JSON.parse(
      localStorage.getItem('authentication')
    ).codigo_usuario

    const param = {
      numero_nota: nunota?.pedido_compra,
      nunota: nunota?.numero_nota,
      sequencia: nunota?.sequencia,
      codprod: nunota?.cod_prod,
      observacao: desc,
      cod_usu: codUsuario,
    }

    console.log('estou enviando isso', param)

    const response = await baseURL.post(
      '/pedido/atualiza-historico-nota-acompanhamento',
      param
    )

    console.log('resposta da api', response)
    setLoading(false)
    submitForm()
  }

  //pegar o dadosDrawer.historico_obs que é uma string, e transformar em array para poder usar o map e mostrar na tela cada posicao que tenha o * e depois tirar o * e mostrar o texto

  React.useEffect(() => {
    if (dadosDrawer?.historico_obs) {
      const array = dadosDrawer?.historico_obs.split('*')
      setChat(array)
    }
  }, [dadosDrawer])

  console.log('chat', chat)

  return (
    <ChakraProvider>
      <Drawer
        isOpen={open}
        placement="right"
        onClick={() => setOpen(!open)}
        finalFocusRef={btnRef}
        onClose={() => setOpen(!open)}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton onClick={() => setOpen(!open)} />
          <DrawerHeader>
            <Text as="h1" fontSize="lg" fontWeight="bold">
              Suas anotações.
            </Text>
            <Text as="h2" fontSize="sm" color="gray.500">
              Numero nota: {nunota?.numero_nota}
            </Text>
          </DrawerHeader>

          <DrawerBody>
            {!description && (
              <Textarea
                placeholder="Escreva aqui..."
                resize="none"
                h="100%"
                onChange={(e) => setDesc(e.target.value)}
                //não deixar o usuario digitar * para não dar erro na hora de mostrar o historico
              />
            )}
            {!!description && (
              <Text fontSize="sm" color="gray.500">
                {dadosDrawer?.historico_obs
                  ? chat.map((item, index) => {
                      if (index !== 0) {
                        return (
                          <Text key={index} as="p">
                            {item}
                          </Text>
                        )
                      }
                    })
                  : 'Sem observações'}
              </Text>
            )}
          </DrawerBody>

          <DrawerFooter>
            {!description && (
              <>
                <Button variant="outline" mr={3} onClick={() => setOpen(false)}>
                  Cancelar
                </Button>
                <Button
                  colorScheme="blue"
                  type="submit"
                  onClick={submitObs}
                  isLoading={loading}
                  disabled={desc.includes('*')}
                >
                  Salvar
                </Button>
              </>
            )}
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </ChakraProvider>
  )
}

export default DrawerUsage
